import axios from 'axios'
import helper from '@/Helper'

const HTTP = axios.create({
  baseURL: process.env.URL_API,
  // baseURL: 'https://passqa.petrolimexaviation.com.vn/api/',
  transformRequest: [
    function (data, headers) {
      headers['Authorization'] = `Bearer ${helper.getToken()}`
      headers['Content-Type'] = 'application/json'
      headers['X-localization'] = helper.getLanguage()
      if (data instanceof FormData) {
        return data
      }
      return JSON.stringify(data)
    }
  ]
})

export default HTTP



// WEBPACK FOOTER //
// ./src/service/AxiosConfig.js